import React from 'react'
import ReactECharts from 'echarts-for-react'
import { EChartsOption } from 'echarts'
import { useTheme } from '../../../components/ThemeProvider'

interface RelatedCasesStatisticsChartProps {
  data: any
}

export default function RelatedCasesStatisticsChart({ data }: RelatedCasesStatisticsChartProps) {
  const theme = useTheme()

  const civilCount = (data?.court_case_info?.civil ?? []).length
  const criminalCount = (data?.court_case_info?.criminal ?? []).length
  const otherCount = (data?.court_case_info?.other ?? []).length

  const chartData = [
    {
      name: '民事案件',
      value: civilCount,
      itemStyle: { color: theme?.primaryColor || '#3B82F6' },
    },
    {
      name: '刑事案件',
      value: criminalCount,
      itemStyle: { color: '#EF4444' },
    },
    {
      name: '其他案件',
      value: otherCount,
      itemStyle: { color: '#6B7280' },
    },
  ]

  const options: EChartsOption = {
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c} ({d}%)',
    },
    legend: {
      bottom: 10,
      left: 'center',
      textStyle: {
        fontSize: 12,
      },
    },
    series: [
      {
        name: '案件统计',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 8,
          borderColor: '#fff',
          borderWidth: 2,
        },
        label: {
          show: true,
          formatter: '{b}\n{d}%',
          fontSize: 12,
          fontWeight: 600,
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 14,
            fontWeight: 'bold',
          },
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
        labelLine: {
          show: true,
          length: 15,
          length2: 10,
        },
        data: chartData,
      },
    ],
  }

  return <ReactECharts option={options} style={{ height: '350px' }} />
}
